<template>
  <div class="edit-project-material-limit">
    <q-form @submit="onSubmit" class="form">
      <div v-if="body?.material_name" class="form__item readonly-row">
        <span class="label">Материал:</span>
        <span>{{ body.material_name }}{{ body.unit_name ? ` (${body.unit_name})` : "" }}</span>
      </div>
      <div class="form__item">
        <CustomInput
          label="Лимит"
          type="number"
          :required="true"
          :value="formData.limit_amount"
          @change_input="(val) => (formData.limit_amount = val)"
        />
      </div>
      <CustomModalFooter :btn-loading="loading" submit-btn-text="Сохранить" />
    </q-form>
  </div>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "edit-project-material-limit",
  components: { CustomInput, CustomModalFooter },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    closeModal: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    const body = this.data?.body || {};
    return {
      loading: false,
      body,
      formData: {
        limit_amount: String(body.limit_amount ?? ""),
      },
    };
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      const payload = {
        sbs_project_material_limit_id: this.body.sbs_project_material_limit_id,
        material_id: this.body.material_id,
        limit_amount: parseFloat(this.formData.limit_amount),
      };
      await this.data?.onSubmit(
        this.data?.project_type_id,
        this.data?.sbs_project_id,
        payload
      );
      this.loading = false;
    },
  },
};
</script>

<style scoped lang="scss">
.edit-project-material-limit {
  max-width: 500px;
}

.form {
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;

  &__item {
    width: 100%;
  }
}

.readonly-row {
  .label {
    font-weight: 500;
    margin-right: 8px;
  }
}
</style>
